import React, { useState, useRef } from 'react';
import { connect } from 'react-redux';
import { Modal, Table, Button, Popconfirm, Input, Divider, message } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { EditOutlined } from '@ant-design/icons';
import intl from 'react-intl-universal';
import { getTimeByUtcOffset } from '@/utils/intl';
import { DATE_TIME_FORMAT } from '@/config';
import * as SettleApi from '@/api/bill/settle';

import { toggleOverStayModalVisible, updateOverStayList } from '@/redux/actions/bill/settle';

import { ROOM_OCC_TYPES, ROOM_OCC_DURATION } from '../config';

import styles from './index.module.scss';

function OverStayModal(props) {
  const { overStayModalVisible, overStayListLoading, overStayList } = props;

  const closeModal = () => {
    props.toggleOverStayModalVisible(false);
  };

  const renderPopconfirmTitle = (value, record) => {
    const inputRef = useRef<Input>(null);
    const [saveLoading, setLoading] = useState(false);

    const updatelList = (item) => {
      const list = overStayList.map((v) => {
        return v.id === item.id ? item : v;
      });
      props.updateOverStayList(list);
    };

    const cancelEdit = (data) => {
      const item = {
        ...data,
        editting: false,
      };
      updatelList(item);
    };

    const edit = (data) => {
      const item = {
        ...data,
        editting: true,
      };
      updatelList(item);
      setTimeout(() => {
        inputRef.current?.focus();
      }, 0);
    };

    const save = async (data) => {
      setLoading(true);
      try {
        const channelOrderNo = inputRef.current?.state?.value;
        const res = await SettleApi.editChannelNo({
          id: data.no, // 记录id
          channelOrderNo, // 渠道单号
        });
        if (res && res.status) {
          const item = {
            ...data,
            editting: false,
            channelOrderNo,
          };
          updatelList(item);
        } else {
          message.error(res.msg || intl.get('bill_alter_channel_bill_no_fail'));
        }
        setLoading(false);
      } catch (err) {
        setLoading(false);
      }
    };
    return (
      <>
        {value}
        <Popconfirm
          title={
            <div className={styles['edit-wrapper']}>
              <Input
                allowClear
                defaultValue={value}
                ref={inputRef}
                placeholder={intl.get('bill_channel_bill_no_max_length')}
                maxLength={200}
                onPressEnter={() => save(record)}
              />
              <Button
                type="link"
                loading={saveLoading}
                onClick={() => save(record)}
                style={{ marginLeft: 12 }}
              >
                {intl.get('app_search_form_save_btn')}
              </Button>
              <Divider type="vertical" />
              <Button type="link" onClick={() => cancelEdit(record)}>
                {intl.get('app_confirm_cancel_btn')}
              </Button>
            </div>
          }
          disabled
          icon={null}
          placement="bottomRight"
          overlayClassName="editPopConfirm"
          visible={record.editting}
        >
          <Button style={{ border: 'none' }} icon={<EditOutlined />} onClick={() => edit(record)} />
        </Popconfirm>
      </>
    );
  };

  const columns: ColumnsType<any> = [
    {
      title: intl.get('app_reservation_live_room_no'),
      dataIndex: 'roomNo',
      key: 'roomNo',
      render: (v) => v || '-',
    },
    {
      title: intl.get('app_reservation_channel_name'),
      dataIndex: 'sourceChannelName',
      key: 'sourceChannelName',
      render: (v) => v || '-',
    },
    {
      title: intl.get('app_reservation_strategy_name'),
      dataIndex: 'priceStrategyName',
      key: 'priceStrategyName',
      render: (v) => v || '-',
    },
    {
      title: intl.get('app_reservation_channel_no'),
      dataIndex: 'channelOrderNo',
      key: 'channelOrderNo',
      render: (val, record) => {
        if (['CRS', 'WALK_IN'].includes(record.sourceChannelType)) return '-';
        return renderPopconfirmTitle(val, record);
      },
    },
    {
      title: intl.get('app_reservation_occ_type'),
      dataIndex: 'occType',
      key: 'occType',
      render: (v, r) => {
        if (r.extensionFlag) return intl.get('app_enum_occ_type_multi');
        return ROOM_OCC_TYPES[v] || '-';
      },
    },
    {
      title: intl.get('app_reservation_checkin_time'),
      dataIndex: 'checkInTime',
      key: 'checkInTime',
      render: (v) => getTimeByUtcOffset(v, DATE_TIME_FORMAT) || '-',
    },
    {
      title: intl.get('app_reservation_checkout_time'),
      dataIndex: 'checkoutTime',
      key: 'checkoutTime',
      render: (v) => getTimeByUtcOffset(v, DATE_TIME_FORMAT) || '-',
    },
    {
      title: intl.get('app_reservation_occ_duration'),
      dataIndex: 'occDuration',
      key: 'occDuration',
      render: (v, record) =>
        v
          ? `${v}${ROOM_OCC_DURATION[record.occType] || intl.get('app_enum_occ_type_day_unit')}`
          : '-',
    },
  ];

  return (
    <Modal
      width="60%"
      visible={overStayModalVisible}
      title={intl.get('drawer_checkout_room_content_extension_detail_btn')}
      destroyOnClose
      footer={<Button onClick={() => closeModal()}>{intl.get('app_confirm_close_btn')}</Button>}
      onCancel={() => closeModal()}
    >
      <Table
        rowKey="id"
        loading={overStayListLoading}
        columns={columns}
        dataSource={overStayList}
        pagination={false}
      />
    </Modal>
  );
}

const mapStateToProps = (state) => {
  const { overStayModalVisible, overStayListLoading, overStayList } = state.settle;
  return { overStayModalVisible, overStayListLoading, overStayList };
};

export default connect(mapStateToProps, {
  toggleOverStayModalVisible,
  updateOverStayList,
})(OverStayModal);
